import { withStyles } from "@material-ui/core";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Creatable from "react-select/lib/Creatable";
import TextField from "@material-ui/core/TextField";
import MaskedInput from "react-text-mask";

const styles = (theme) => ({
  input: {
    display: "flex",
    padding: "0px 0px",
  },
  label: {
    fontSize: 14,
    zIndex: 0,
    transform: `translate(14px, 14px) scale(1)`,
    color: theme.TextColor,
    opacity: 0.7,
  },
  focusedLabel: {},
  notchedOutline: {
    borderColor: theme.iconColor,
  },
  textField: {
    "& $notchedOutline": {
      borderColor: theme.iconColor,
    },
  },
  inputRoot: {
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: theme.iconColor,
        width: 200,
      },
  },
  inputRootWarning: {
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: theme.warningColor,
        width: 200,
      },
    "& $notchedOutline, &$inputFocused $notchedOutline": {
      borderColor: theme.warningColor,
      width: 200,
    },
  },
  inputField: {
    width: 200,
  },
  maskedInput : {
    border: "none",
    "&:focus-visible": {
      outline: "none"
    },
    height : 28,
    width : "45%",
    background : "transparent",
    color : theme.TextColor
  },
  inputFocused: { width: 200 },
  inputDisabled: { width: 200 },
  inputError: { width: 200 },
  driverPopupSelect: {
    "& .select__control": {
      minWidth: 180,
      backgroundColor: "transparent",
      minHeight: 30,
      boxSizing: "border-box",
      border: `1px solid ${theme.iconColor}`,
      fontSize: theme.textFontSize,
      borderRadius: "5px",
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
    },
    "& .select__value-container": {
      color: theme.iconColor,
      "&>.select__single-value": {
        color : theme.TextColor
      },
      "&>.select__multi-value": {
        margin: 2,
        background: theme.AppBGColor,
        "& .select__multi-value__label": {
          color: theme.TextColor,
        },
        "& .select__multi-value__remove": {
          padding: "4px 0",
          cursor: "pointer",
        },
      },
    },
    "& .select__indicators": {
      paddingRight: 4,
      cursor: "pointer",
      color: theme.iconColor,
      "& .select__clear-indicator": {
        padding: 4,
      },
      "& .select__indicator-separator": {
        height: 24,
        margin: 0,
        display: "none",
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "0 0 2px 2px",
      borderTop: "none",
      "& .select__menu-list": {
        maxHeight: 139,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
        color: theme.iconColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },
});

const CustomTextInput = (props) => {
  const { innerRef, mask, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        innerRef(ref ? ref.inputElement : null);
      }}
      className={props.selectProps.classes.maskedInput}
      mask={props.selectProps.mask}
      pipe={(value) => (value ? value.trim().toUpperCase() : "")}
      guide={false}
    />
  );
};

const inputComponent = ({ inputRef, value, ...props }) => {
  return <div ref={inputRef} {...props} />;
};

const Control = (props) => {
  const { classes } = props.selectProps;
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
        classes: {
          root: classes.inputRoot,
          input: `${classes.inputField}`,
          notchedOutline: classes.notchedOutline,
          focused: classes.inputFocused,
          disabled: classes.inputDisabled,
          error: classes.inputError,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
};

const isValidNewOption = (inputValue, selectOptions, format) => {
  return (
    inputValue &&
    selectOptions.findIndex((option) => option.label === inputValue) < 0 &&
    format &&
    format.test(inputValue)
  );
};

const Dropdown = ({
  classes,
  onChange,
  options,
  value,
  name,
  error,
  textFieldProps,
  theme,
  format,
  ...otherProps
}) => {
  const selectStyles = {
    input: (base) => ({
      ...base,
      color: theme.TextColor,
      "& input": {
        font: "inherit",
      },
    }),
  };
  return (
    <Creatable
      classes={classes}
      styles={selectStyles}
      classNamePrefix={"select"}
      className={classes.driverPopupSelect}
      name={name}
      value={value}
      onChange={onChange}
      menuPlacement="auto"
      menuPosition="absolute"
      closeMenuOnSelect
      isValidNewOption={(inputValue, selectedOptions) =>
        isValidNewOption(inputValue, selectedOptions, format)
      }
      components={{
        DropdownIndicator: (props) => (
          <ArrowDropDown {...props.innerProps} className={classes.iconStyle} />
        ),
        Control,
        ...(otherProps?.mask && { Input: CustomTextInput }),
      }}
      textFieldProps={{
        InputLabelProps: {
          classes: {
            root: classes.label,
            focused: classes.focusedLabel,
          },
        },
        ...textFieldProps,
        error: Boolean(error || ""),
      }}
      {...otherProps}
      options={options}
    />
  );
};

export default withStyles(styles, { withTheme: true })(Dropdown);
